import React from "react";
import ContactConnectedProfilePopup from "./ContactConnectedProfilePopup";
import ContactNameWithAvatar from "./ContactNameWithAvatar";

interface IContactNameWithAvatarPopup {
  personId: number;
  firstName?: string;
  lastName?: string;
}

/**
 * Render's a contact's name with an avatar and a popup that shows their connected profile.
 *
 * @param personId - The ID of the person to show in the popup.
 * @param firstName - The first name of the person
 * @param lastName - The last name of the person
 */
export default function ContactNameWithAvatarPopup({
  personId,
  firstName = "",
  lastName = "",
}: IContactNameWithAvatarPopup) {
  return (
    <ContactConnectedProfilePopup
      personId={personId}
      trigger={<ContactNameWithAvatar firstName={firstName} lastName={lastName} />}
    />
  );
}
